import * as THREE from 'three';
import { fragment, vertex } from './bubbleShader';
import {gsap} from "gsap/all";
import autoBind from "auto-bind";
import { GUI } from 'dat.gui'

const PROPS = {
  noise: 1,
  hoverRadius: 0,
  roughness: 0,
  distortionLevel: 1,
  tempo: 1,
};
class Bubble extends THREE.Mesh {
  intersected = false;

  recees = 3;

  popping = false;

  constructor(props) {
    super(new THREE.SphereGeometry(2, 120, 120));
    autoBind(this);

    this.props = { ...PROPS, ...props };

    this.createMaterial();

    window.addEventListener('click', () => {
      if (this.intersected) {
        if (!this.material?.userData?.shader?.uniforms && !this.popping) return;
        this.popping = true;
        gsap
            .to(this.material.userData.shader.uniforms.uRecees, { value: -0.9, duration:0.2 })
            .then(() => {
              gsap.to(this.material.userData.shader.uniforms.uRecees, { value: 0, duration:0.2 })
              this.popTime = this.material.userData.shader.uniforms.uTime.value;
              this.intersected = false;
            })
      }
    });
  }

  createMaterial() {
    this.material = new THREE.MeshPhysicalMaterial({
      thickness: 1,
      reflectivity: 0.01,
      transmission: 1,
      roughness: 0,
      metalness: 0,
      clearcoat: 0,
      clearcoatRoughness: 0,
      opacity:0.6,
      color: new THREE.Color(0xfff2f4),
      ior: 1.06,
      transparent: true,
      side: THREE.DoubleSide,
      onBeforeCompile: (shader) => {
        shader.uniforms.uNoise = { value: this.props.noise };
        shader.uniforms.uHoverRadius = { value: this.props.hoverRadius };
        shader.uniforms.uRecees = { value: this.recees };
        shader.uniforms.uDistortionLevel = { value: this.props.distortionLevel };
        shader.uniforms.uTempo = { value: this.props.tempo };

        shader.uniforms.uTime = { value: 0 };
        shader.uniforms.uPopTime = { value: 0 };
        shader.uniforms.uIntersectPoint = { value: new THREE.Vector3(-10) };

        shader.fragmentShader = fragment;
        shader.vertexShader = vertex;

        this.material.userData.shader = shader;
        this.createGui();
      },
    });
    this.material.thickness = 25.0

    this.castShadow = true;
    this.receiveShadow = true;
  }

  cancelIntersection() {
    if (!this.material?.userData?.shader?.uniforms || !this.intersected || this.popping) return;
    this.intersected = false;
    this.material.userData.shader.uniforms.uIntersectPoint.value = new THREE.Vector3(-10);
  }

  intersectPoint(p) {
    if (!this.material?.userData?.shader?.uniforms || this.popping) return;
    this.intersected = true;
    this.material.userData.shader.uniforms.uIntersectPoint.value = p;
  }

  tick(time, animate) {
    if (!this.material?.userData?.shader?.uniforms) return;

    this.material.userData.shader.uniforms.uDistortionLevel.value = this.props.distortionLevel
    this.material.userData.shader.uniforms.uTempo.value = this.props.tempo
    this.material.userData.shader.uniforms.uNoise.value = this.props.noise


    if (animate) this.material.userData.shader.uniforms.uTime.value = time;
    if (this.popTime) this.material.userData.shader.uniforms.uPopTime.value = time - this.popTime;
  }

  createGui () {
    if (this.bubbleFolder) return
    this.bubbleFolder = window.gui.addFolder('Bubble Uniforms')
    this.bubbleFolder
        .add(this.props, 'distortionLevel', 0, 50)
        .name('Distortion')
        .listen()
    this.bubbleFolder
        .add(this.props, 'tempo', 0, 20)
        .name('Tempo')
        .listen()
    this.bubbleFolder
        .add(this.props, 'noise', 0, 10)
        .name('Noise')
        .listen()

    this.bubbleFolder.open()
  }
}

export default Bubble;
